import Reveal from "@/components/Reveal";
import Seo from "@/components/Seo";
import BookingForm from "@/components/BookingForm";

export default function Book() {
  return (
    <div className="pt-32 md:pt-40 pb-24">
      <Seo
        title="Book Your Stay — Best Direct Rates"
        description="Reserve your room at Hotel Azulo Inn, Safdarjung Enclave, New Delhi. Book direct for the best rates — our reservations team confirms availability within the day."
        path="/book"
      />
      <div className="relative">
        <div className="relative max-w-7xl mx-auto px-6 md:px-12">
          <Reveal>
            <div className="overline">Reserve</div>
            <h1 className="mt-6 font-serif text-5xl md:text-7xl leading-[0.98] text-ink-900 max-w-3xl">
              A quiet evening,
              <span className="italic text-sage-dark"> held for you.</span>
            </h1>
            <p className="mt-8 max-w-xl text-ink-700 leading-relaxed">
              Share your dates and room preference. Tariffs are dynamic — our reservations team
              confirms availability and rates within the day. Live booking with instant
              confirmation (eZee Absolute booking engine) will be enabled here shortly.
            </p>
          </Reveal>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-6 md:px-12 mt-16 md:mt-20 p-8 md:p-14 border hairline bg-paper-100">
        <BookingForm />
      </div>
    </div>
  );
}
